export function tryStringify(value: unknown): string | undefined {
  if (value && Array.isArray(value)) {
    return value.map(tryStringify).filter(Boolean).join(', ')
  }

  return value ? String(value) : undefined
}
